<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-col cols="12">
      <v-alert v-if="errors" prominent type="error" color="red" dense>{{ errors }}</v-alert>
      <v-alert v-if="success" prominent type="success" color="green" dense>{{ success }}</v-alert>
    </v-col>
    <v-card-title>
      Hospital Ledger
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="3">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Select Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" range></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="1" class="mx-2">
        <v-btn depressed color="primary" v-on:click="getReports" :loading="loadingstatus">Search</v-btn>
      </v-col>
      <v-col cols="12" sm="6" md="1">
        <v-btn depressed color="primary" v-on:click="printList">Print</v-btn>
      </v-col>
    </v-card-title>

    <v-card class="mb-4">
      <strong>Summary</strong>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">Title</th>
            <th class="text-left">Amount</th>
          </tr>
          </thead>
          <tbody>
          <tr><td colspan="2"><strong>Collection</strong></td></tr>
          <tr>
            <td>Consultation</td>
            <td v-if="desserts">{{ desserts.con_ledger_total }}</td>
          </tr>
          <tr>
            <td>Overseas</td>
            <td v-if="desserts">{{ desserts.overseas_ledger_total }}</td>
          </tr>
          <tr>
            <td>Investigation</td>
            <td v-if="desserts">{{ desserts.inv_ledger_total_debit }}</td>
          </tr>
          <tr>
            <td>Operation</td>
            <td v-if="desserts">{{ desserts.op_ledger_total }}</td>
          </tr>
          <tr v-if="shop_data.length">
            <td>Shop Sale &amp; Service</td>
            <td v-if="desserts">{{ desserts.shop_total_payamount }}</td>
          </tr>
          <tr>
            <th class="text-right">Total Collection</th>
            <th v-if="desserts">{{ desserts.hospital_total_debit }}</th>
          </tr>

          <tr><td colspan="2"><strong>Deduction / Credit</strong></td></tr>
          <tr>
            <td>Consultation Refund To Customer</td>
            <td v-if="desserts">- {{ desserts.consultation_refund }}</td>
          </tr>
          <tr>
            <td>Investigation Refund To Customer</td>
            <td v-if="desserts">- {{ desserts.investigation_refund }}</td>
          </tr>
          <tr>
            <td>Investigation Due Amount</td>
            <td v-if="desserts">- {{ desserts.inv_total_due }}</td>
          </tr>
          <tr>
            <td>Investigation Discount Amount</td>
            <td v-if="desserts">- {{ desserts.inv_total_discount }}</td>
          </tr>
          <tr>
            <td>Cashback To Patient</td>
            <td v-if="desserts">- {{ desserts.cashback_total }}</td>
          </tr>

          <tr>
            <th class="text-right">Hospital Ledger Balance</th>
            <th v-if="desserts">{{ desserts.hospital_total_balance }}</th>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>

    <v-card id="print">
      <strong>Details</strong>
      <br />
      <strong>Consultation</strong>
      <v-data-table
          :headers="consultancy_header"
          :items="consultancy_desserts"
          class="elevation-1"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ consultancy_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <th>Refund To Customer Amount:</th>
            <td></td>
            <td></td>
            <th v-if="desserts">{{ desserts.consultation_refund }}</th>
            <th v-if="desserts"></th>
          </tr>
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <td></td>
            <th>Hospital Amount:</th>
            <th v-if="desserts">{{ desserts.con_ledger_total }}</th>
            <th v-if="desserts">{{ desserts.consultation_refund }}</th>
            <th v-if="desserts"></th>
          </tr>
        </template>
      </v-data-table>
      <br />

      <strong>Overseas</strong>
      <v-data-table
          :headers="overseas_header"
          :items="overseas_desserts"
          class="elevation-1"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ overseas_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <td></td>
            <th>Hospital Amount:</th>
            <th v-if="desserts">{{ desserts.overseas_ledger_total }}</th>
          </tr>
        </template>
      </v-data-table>
      <br />

      <strong>Investigation</strong>
      <v-data-table
          :headers="investigation_header"
          :items="investigation_desserts"
          class="elevation-1"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ investigation_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <th>Invoice Due Collect:</th>
            <td></td>
            <th v-if="desserts">{{ desserts.inv_due_collect }}</th>
            <th v-if="desserts"></th>
            <td></td>
          </tr>
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <th>Refund To Customer Amount:</th>
            <td></td>
            <td></td>
            <th v-if="desserts">{{ desserts.investigation_refund }}</th>
            <th v-if="desserts"></th>
          </tr>
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <th>Invoice To Due:</th>
            <td></td>
            <td></td>
            <th v-if="desserts">{{ desserts.inv_total_due }}</th>
            <th v-if="desserts"></th>
          </tr>
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <th>Invoice To Discount Amount:</th>
            <td></td>
            <td></td>
            <th v-if="desserts">{{ desserts.inv_total_discount }}</th>
            <th v-if="desserts"></th>
          </tr>
        </template>
        <template slot="body.append">
          <tr>
            <td></td>
            <td></td>
            <th>Hospital Amount:</th>
            <th v-if="desserts">{{ desserts.inv_ledger_total_debit }}</th>
            <th v-if="desserts">{{ desserts.inv_ledger_total_credit }}</th>
            <th v-if="desserts"></th>
          </tr>
        </template>
      </v-data-table>
      <br />

      <strong>Operation</strong>
      <v-data-table
          :headers="operation_header"
          :items="operation_desserts"
          class="elevation-1"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ operation_desserts.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>
            <th></th>
            <th></th>
            <th>Hospital Amount:</th>
            <th v-if="desserts">{{ desserts.op_ledger_total }}</th>
            <th v-if="desserts"></th>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <br />
    <v-card v-if="shop_data.length">
      <strong>Shop Sale &amp; Service Summary</strong>
      <v-data-table
          :headers="shop_summary_header"
          :items="shop_data"
          class="elevation-1"
          :loading="loadingstatus"
          :hide-default-footer="true"
          disable-pagination
      >
        <template v-slot:item.slno="{ item }">
          {{ shop_data.indexOf(item) + 1 }}
        </template>
        <template slot="body.append">
          <tr>
            <th></th>
            <th>Hospital Amount:</th>
            <th v-if="desserts">{{ desserts.shop_total_payamount }}</th>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import atshq from "../../../js/setup";
import moment from "moment/moment";

export default {
  data() {
    return {
      errors: null,
      success: null,
      date: [
        moment().format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      menu2: false,
      loadingstatus: false,
      login_user_id: localStorage.getItem("userId"),
      desserts: [],
      consultancy_desserts: [],
      consultancy_header: [
        { text: "SL", value: "slno" },
        { text: "Ledger Name", value: "item_name" },
        { text: "Quantity", value: "item_qty" },
        { text: "Hospital Bill(Debit)", value: "total_invoice_amount" },
        { text: "Hospital Bill(Credit)" },
      ],
      overseas_desserts: [],
      overseas_header: [
        { text: "SL", value: "slno" },
        { text: "Ledger Name", value: "item_name" },
        { text: "Quantity", value: "item_qty" },
        { text: "Hospital Bill", value: "total_invoice_amount" },
      ],
      investigation_desserts: [],
      investigation_header: [
        { text: "SL", value: "slno" },
        { text: "Ledger Name", value: "item_name" },
        { text: "Quantity", value: "item_qty" },
        { text: "Hospital Bill(Debit)", value: "total_invoice_amount" },
        { text: "Hospital Bill(Credit)" },
      ],
      operation_desserts: [],
      operation_header: [
        { text: "SL", value: "slno" },
        { text: "Ledger Name", value: "item_name" },
        { text: "Quantity", value: "item_qty" },
        { text: "Hospital Bill", value: "total_invoice_amount" },
      ],
      shop_data: [],
      shop_summary_header: [
        { text: "SL", value: "slno" },
        { text: "Shop Name", value: "shop_name" },
        { text: "Sale Amount", value: "total_payamount" },
      ],
      items: [
        { text: "Dashboard", disabled: false, href: "/" },
        { text: "Hospital Ledger", disabled: true, href: "patients" },
      ],
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
    };
  },

  created() {
    this.getReports();
  },

  methods: {
    getReports() {
      this.loadingstatus = true;
      if (!this.date || !this.date.length) {
        this.loadingstatus = false;
        this.$noty.error("Please select date range.");
        return false;
      }

      const sortedDate = [...this.date].sort().join(",");

      atshq
          .get("invoices/total-hospital-ledger?date=" + sortedDate + "&login_user_id=" + this.login_user_id)
          .then((response) => {
            this.desserts = response.data.data;
            this.consultancy_desserts = response.data.data.con_ledger || [];
            this.overseas_desserts = response.data.data.overseas_ledger || [];
            this.investigation_desserts = response.data.data.inv_ledger || [];
            this.operation_desserts = response.data.data.op_ledger || [];
            this.shop_data = response.data.data.shop_data || [];
            this.loadingstatus = false;
            this.errors = null;
          })
          .catch((e) => {
            this.loadingstatus = false;
            if (e.response && e.response.data && e.response.data.message) {
              this.errors = e.response.data.message;
            } else {
              this.errors = e.message || "Failed to load data.";
            }
          });
    },

    printList() {
      if (!this.date || !this.date.length) {
        this.$noty.error("Please select date range.");
        return;
      }
      const sortedDate = [...this.date].sort().join(",");
      window.open(this.returnApiBaseURL + "print/hospital-ledger-print?date=" + sortedDate);
    },
  },
};
</script>
